import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Sparkles, BookOpen, FileText } from "lucide-react";

export const Route = createFileRoute("/admin/tools")({
  head: () => ({
    meta: [
      { title: "Loan officer tools · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AdminTools,
});

const TOOLS = [
  {
    to: "/lo/str-report",
    title: "Short-term rental analyzer",
    desc: "Model acquisition, arbitrage, owned, and co-host STR scenarios and push results to a client's file.",
    icon: Sparkles,
  },
  {
    to: "/lo/guidelines",
    title: "Lending guidelines library",
    desc: "Source-of-truth lender product matrices for pricing, LTV, FICO, reserves, and eligibility.",
    icon: BookOpen,
  },
  {
    to: "/lo/documents",
    title: "Document checklists",
    desc: "Product-by-product document requirements to send borrowers.",
    icon: FileText,
  },
] as const;

function AdminTools() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-black tracking-tight">Loan officer tools</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Day-to-day tools for scenario review, guideline checks, and borrower document requests.
        </p>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {TOOLS.map((t) => (
          <Link key={t.to} to={t.to} className="group">
            <Card className="h-full transition group-hover:border-brand/60 group-hover:shadow-md">
              <CardHeader>
                <div className="flex items-center gap-3">
                  <div className="rounded-lg bg-brand/10 p-2 text-brand">
                    <t.icon className="h-5 w-5" />
                  </div>
                  <CardTitle className="text-base">{t.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <CardDescription>{t.desc}</CardDescription>
              </CardContent>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
